import clsx from 'clsx'
import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

export const EmptyCircleImage = ({
  style,
  children,
  className,
}: {
  style?: CSSProperties
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div className={clsx(s.container, className)} style={style}>
      {children}
    </div>
  )
}
